import index from "./projectEdit.vue";
export default index;
